import DOM from '@common/DOM/DOM'

import SideMenuBg   from './components/SideMenuBg/SideMenuBg'
import NavbarButton from './components/NavbarButton/NavbarButton'

import renderButtons from './utils/renderButtons'

import type { INavProps } from './definitions'
import { ENavbarEvent } from './definitions'

import './Navbar.css'

/**
 * Navbar komponens. Honlapok tetejére, felső menü sáv.
 * @param props - Navbar props {@link INavProps}.
 */
export default function Navbar (props: INavProps): DocumentFragment {
  const { buttonProps, children } = props

  const sideMenu: HTMLElement = (
    <div className="sen-navbar__side-menu">
      { renderButtons(buttonProps, 'side') }
    </div>
  )

  sideMenu.addEventListener('click', () => {
    DOM.dispatch(document, ENavbarEvent.HideSideMenu)
  })

  let hamburger: HTMLElement

  /** Oldalsó menü elrejtése. */
  function hideSideMenu (): void {
    sideMenu.removeAttribute('data-selected')
    hamburger.removeAttribute('data-selected')
  }

  /** Oldalsó menü megjelenítése. */
  function showSideMenu (): void {
    sideMenu.setAttribute('data-selected', '')
    hamburger.setAttribute('data-selected', '')

    DOM.dispatch(document, ENavbarEvent.ShowSideMenu)
  }

  /** Oldalsó menü megjelenítése/elrejtése. */
  function onClickHamburger (): void {
    if (sideMenu.hasAttribute('data-selected')) {
      hideSideMenu()
    }
    else {
      showSideMenu()
    }
  }

  hamburger = (
    <NavbarButton
      type="hamburger"
      onClick={ onClickHamburger }
    />
  )

  const navbar: DocumentFragment = (
    <Fragment>
      <div className="sen-navbar">
        { children ?? null }

        <nav className="sen-navbar__list">
          { renderButtons(buttonProps) }
        </nav>
      </div>

      { hamburger }
      { sideMenu }
      <SideMenuBg />
    </Fragment>
  )

  document.addEventListener(ENavbarEvent.HideSideMenu, hideSideMenu)

  return navbar
}
